// extracted by mini-css-extract-plugin
module.exports = {"cartDiscountPrice":"cartDiscountPrice_cartDiscountPrice__LgsiS","salePrice":"cartDiscountPrice_salePrice__Xe6p5","originalPrice":"cartDiscountPrice_originalPrice__hMbed"};